import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "input", "submit" ]

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.hasInputTarget && this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.inputTarget.value
    }
  }
}
